import React, { useState, useRef, useCallback } from 'react';
import WheelMascot from './WheelMascot';

/**
 * Logo lockup: WheelMascot + site name side by side.
 *
 * On hover the wheel spins for 1.5 seconds then settles — just enough motion
 * to feel alive without becoming a distraction. Designed for the nav header.
 */
interface LogoLockupProps {
  className?: string;
}

const LogoLockup: React.FC<LogoLockupProps> = ({ className = '' }) => {
  const [spinning, setSpinning] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleHover = useCallback(() => {
    if (spinning) return; // don't restart while already spinning
    setSpinning(true);
    timerRef.current = setTimeout(() => setSpinning(false), 1500);
  }, [spinning]);

  // Clean up timer on unmount
  React.useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <span
      className={`inline-flex items-center gap-2 select-none ${className}`}
      onMouseEnter={handleHover}
    >
      <WheelMascot size={32} spinning={spinning} />
      <span className="font-extrabold text-base tracking-tight leading-none">
        <span className="text-gray-400 dark:text-gray-400 font-normal">The</span>
        <span className="text-violet-400 font-extrabold">NameWheel</span>
      </span>
    </span>
  );
};

export default LogoLockup;
